import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import api from '../../../services/api';
import WithoutSites from '../WithoutSites';
import WithSites from '../WithSites';
import { LoaderMain as Loader } from '../../../components/Loader';
import { ContentTitle } from '../../../components/utilities/styledComponents/ContentTitle';

const Sites = () => {
	const [showLoader, setShowLoader] = useState(true);
	const [hasSites, setHasSites] = useState(false);
	const pageName = [
		'Sites sem produto',
		'Sites com produto',
	];
	document.title = 'Site';
	const registerTagManager = (accessedPageName) => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: accessedPageName,
			},
			dataLayerName: 'Sites',
		});
	};

	useEffect(() => {
		api.get('/users/me/products')
		.then((response) => {
			const data = response.data;
			if (typeof data.data.attributes.products !== 'undefined'
				&& data.data.attributes.products !== null
			) {
				const products = data.data.attributes.products instanceof Array
					? data.data.attributes.products.join(',')
					: Object.values(data.data.attributes.products).join(',');

				const productsArray = products ? products.split(',') : [];
				const parsedProductsArray = productsArray.map(str => str.toLowerCase());

				if (products && parsedProductsArray.includes('sites')) {
					registerTagManager(pageName[1]);
					setHasSites(true);
				} else {
					registerTagManager(pageName[0]);
				}
			}
			setShowLoader(false);
		});
	}, []);

	if (showLoader) {
		return (
			<div style={{ paddingLeft: '30px' }}>
				<div className="page-container">
					<article id="home-page">
						<div className="content-welcome p-0">
							<ContentTitle
								lineheight="1.2em"
								fontSize="32px"
								padding="18px 29px"
							>
								Sites
							</ContentTitle>
						</div>
					</article>
				</div>
				<div style={{ padding: '30px' }}>
					<Loader />
				</div>
			</div>
		);
	}

    return !hasSites ? (
	<div style={{ paddingLeft: '30px' }}>
		<div className="page-container">
			<article id="home-page">
				<div className="content-welcome p-0">
					<ContentTitle
						lineheight="1.2em"
						fontSize="32px"
						padding="18px 29px"
					>
						Sites
					</ContentTitle>
				</div>
			</article>
		</div>
		<div style={{ paddingLeft: '30px' }}>
			<WithoutSites />
		</div>
	</div>
        ) : <WithSites />;
};

export default Sites;
